<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="dialog"
      persistent
      max-width="560px"
    >
      <v-card>
        <form @submit.prevent="submit">
          <v-card-title class="pb-0">
            <span class="headline">{{ $t('finance.depositOrWithdrawTitle') }}</span>
            <v-spacer />
            <v-btn
              flat
              icon
              @click="close"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-alert
              v-if="done"
              type="success"
            >
              {{ $t('finance.saved') }}
            </v-alert>
            <v-alert
              v-if="error"
              type="error"
            >
              {{ errorMessage }}
            </v-alert>
            <p class="grey--text text--darken-1 caption px-2 mb-2">
              {{ $t('finance.adjustsCapitalBookNote') }}
            </p>
            <v-layout wrap>
              <v-flex
                xs12
                class="px-2"
              >
                <v-select
                  v-model="form.type"
                  :items="typeItems"
                  item-text="text"
                  item-value="value"
                  :label="$t('columns.type') + ' *'"
                />
              </v-flex>
              <v-flex
                xs12
                class="px-2"
              >
                <v-text-field
                  v-model.number="form.amount"
                  :label="$t('columns.amount') + ' *'"
                  type="number"
                  min="0.01"
                  step="0.01"
                  @input="clearFieldError"
                />
              </v-flex>
              <v-flex
                xs12
                class="px-2"
              >
                <v-text-field
                  v-model="form.note"
                  :label="$t('finance.noteOptionalLabel')"
                  :placeholder="$t('finance.noteReasonPlaceholder')"
                  multi-line
                  :rows="3"
                  :hint="$t('finance.noteShownHint')"
                  persistent-hint
                  @input="clearFieldError"
                />
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              outline
              @click="close"
            >
              {{ $t('common.cancel') }}
            </v-btn>
            <v-btn
              color="primary"
              type="submit"
              :loading="loading"
            >
              {{ $t('common.save') }}
            </v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    value: { type: Boolean, default: false }
  },

  data() {
    return {
      form: {
        type: 'deposit',
        amount: null,
        note: ''
      },
      typeItems: [
        { text: this.$t('finance.depositAddToCapitalBook'), value: 'deposit' },
        { text: this.$t('finance.withdrawSubtractFromCapitalBook'), value: 'withdraw' }
      ],
      loading: false,
      done: false,
      error: false,
      errorMessage: this.$t('finance.couldNotSave')
    }
  },

  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },

  watch: {
    value(v) {
      if (v) {
        this.form = { type: 'deposit', amount: null, note: '' }
        this.done = false
        this.error = false
        this.errorMessage = this.$t('finance.couldNotSave')
      }
    }
  },

  methods: {
    close() {
      this.error = false
      this.$emit('input', false)
    },

    clearFieldError() {
      if (this.error) {
        this.error = false
      }
    },

    submit() {
      const amountNum = Number(this.form.amount)
      const amountOk = !Number.isNaN(amountNum) && amountNum >= 0.01
      if (!amountOk) {
        this.error = true
        this.errorMessage = this.$t('finance.enterValidAmountError')
        return
      }
      const token = localStorage.getItem('access_token')
      this.loading = true
      this.error = false
      axios
        .post('api/capital_movements', this.form, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(() => {
          this.done = true
          this.$emit('saved')
          setTimeout(() => {
            this.done = false
            this.close()
          }, 1200)
        })
        .catch((err) => {
          this.error = true
          const msg =
            err.response &&
            err.response.data &&
            (err.response.data.message || err.response.data.error)
          this.errorMessage = msg || this.$t('finance.couldNotSave')
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/capital/modals/CapitalMovementModal.vue